'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var trash = require('./trash-3115d8cf.js');
var button = require('./button-d7f037ee.js');

var UploadButton = styled__default(button.Button)(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  border: ", ";\n  margin-top: 10px;\n"], ["\n  color: ", ";\n  border: ", ";\n  margin-top: 10px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
}, function (_a) {
    var theme = _a.theme;
    return "1px " + theme.colors.greys.sharedDarkGrey + " solid";
});
var Container = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n"], ["\n"])));
var InvisibleInput = styled__default.input(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: none;\n"], ["\n  display: none;\n"])));
var FilesContainer = styled__default.div(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  padding: 5px 0px 15px 16px;\n"], ["\n  padding: 5px 0px 15px 16px;\n"])));
var FileIconBlock = styled__default.div(templateObject_5 || (templateObject_5 = tslib_es6.__makeTemplateObject(["\n  display: flex;\n  width: 300px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n"], ["\n  display: flex;\n  width: 300px;\n  align-items: center;\n  flex-direction: row;\n  justify-content: space-between;\n"])));
var DeleteIcon = styled__default(trash.Trash)(templateObject_6 || (templateObject_6 = tslib_es6.__makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var FileText = styled__default.div(templateObject_7 || (templateObject_7 = tslib_es6.__makeTemplateObject(["\n  font: normal 500 12px/21px ", ";\n  width: 275px;\n  padding-right: 16px;\n  color: ", ";\n"], ["\n  font: normal 500 12px/21px ", ";\n  width: 275px;\n  padding-right: 16px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.secondary;
});
var ErrorText = styled__default.div(templateObject_8 || (templateObject_8 = tslib_es6.__makeTemplateObject(["\n  padding: 0px 0px 16px 15px;\n  font: normal 500 14px/16px ", ";\n  color: ", ";\n"], ["\n  padding: 0px 0px 16px 15px;\n  font: normal 500 14px/16px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.admin.pink;
});
var UploadWrapper = styled__default.label(templateObject_9 || (templateObject_9 = tslib_es6.__makeTemplateObject(["\n"], ["\n"])));
var Subtitle = styled__default.div(templateObject_10 || (templateObject_10 = tslib_es6.__makeTemplateObject(["\n  padding-top: 5px;\n  font: italic normal 12px/14px ", ";\n  color: ", ";\n"], ["\n  padding-top: 5px;\n  font: italic normal 12px/14px ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.sharedDarkGrey;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9, templateObject_10;

var truncateFileName = function (name, truncateTo) {
    var typeMarker = name.lastIndexOf('.');
    var fileEnding = name.substr(typeMarker, name.length - 1);
    return name.substr(0, truncateTo) + "..." + name.substr(typeMarker - 3, 3) + fileEnding;
};

var FileBlock = function (_a) {
    var files = _a.files, deleteFile = _a.deleteFile;
    return (React__default.createElement(FilesContainer, null, files.map(function (file, index) { return (React__default.createElement(FileIconBlock, { key: file.name },
        React__default.createElement(FileText, null, file.name.length < 45 ? file.name : truncateFileName(file.name, 35)),
        React__default.createElement(DeleteIcon, { "data-testid": "delete-button-" + index, variant: "adminGreyDark", size: "xs", onClick: deleteFile(index) }))); })));
};

exports.Container = Container;
exports.ErrorText = ErrorText;
exports.FileBlock = FileBlock;
exports.InvisibleInput = InvisibleInput;
exports.Subtitle = Subtitle;
exports.UploadButton = UploadButton;
exports.UploadWrapper = UploadWrapper;
exports.truncateFileName = truncateFileName;
